import { eManulSortLayerDrawOrder, Game } from "../../../Game";
import { Node } from "../../../Utils/Collections/Node";
import { NodeList } from "../../../Utils/Collections/NodeList";
import { DecoEntityProvider } from "./DecoEntityProvider";
import { DecoType, DecoTypeSettings } from "./DecoType";



export interface FlagSettings {
    typeId: number;
    pos: pc.Vec3;
}



export class FlagManager {
    private static _flagTypeSettings: DecoTypeSettings[];

    private _batchGroupId: number;
    private _flagTypes: NodeList<DecoType>;

    get isActive(): boolean { return this._isActive; }
    set isActive(val: boolean) {
        if (val != this._isActive) {
            this._isActive = val;
            this._flagTypes.forEach((type: DecoType): void => { type.isActive = val; });
        }
    }
    private _isActive: boolean;

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    constructor(id: number, flagSettings: FlagSettings[], material: pc.StandardMaterial) {
        if (!FlagManager._flagTypeSettings) {
            FlagManager._flagTypeSettings = [
                new DecoTypeSettings("flags/0/", 21, 15, 60),
                new DecoTypeSettings("flags/1/", 13, 9, 70),
            ];
        }

        // Batch group
        this._batchGroupId = Game.app.batcher.addGroup("flags" + id, true, 100, undefined, [Game.manualSortLayer.id]).id;
        Game.app.on("batch:created" + this._batchGroupId, (batch: pc.Batch) => { batch.meshInstance.drawOrder = eManulSortLayerDrawOrder.flags; });

        // Ziskat pocet vlajek od jednotlivych typu
        let flagsPerType: number[] = [];

        for (let i = 0; i < FlagManager._flagTypeSettings.length; i++)
            flagsPerType[i] = 0;

        flagSettings.forEach((fs: FlagSettings): void => {
            flagsPerType[fs.typeId]++;
        });

        // Vytvorit entity pro jednotlive typy vlajek
        this._flagTypes = new NodeList<DecoType>();

        FlagManager._flagTypeSettings.forEach((fts: DecoTypeSettings, i: number): void => {
            this._flagTypes.add(new DecoType(fts, flagsPerType[i], material, Game.app.root, this._batchGroupId));
        });

        // Vytvorit poskytovatele entit
        let entProvider = new DecoEntityProvider(this._flagTypes);

        // Zobrazit vlajky na jednotlivych pozicich
        flagSettings.forEach((fs: FlagSettings): void => {
            let entPkg = entProvider.getEntity(fs.typeId);

            entPkg.positon.copy(fs.pos);
            entPkg.entity.setPosition(fs.pos);
        });

        this._isActive = true;
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    reset(): void {
        this._flagTypes.forEach((type: DecoType): void => { type.reset(); });
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    update(): void {
        if (this._isActive) {
            this._flagTypes.every((type: DecoType, node: Node<DecoType>): boolean => {
                if (type.update()) {
                    this._flagTypes.removeByNode(node);
                    this._flagTypes.add(type);

                    return false;
                }

                return true;
            });
        }
    }
}